import React from 'react';
import './style.scss';
import { StaticImage } from 'gatsby-plugin-image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'gatsby';
import Button from '../Button/Button';
import { getImageUrl } from '../../utils/helpers';

function Insights({ insights, contentType, line }) {
  const swiperConfig = {
    350: {
      slidesPerView: 1.8,
      spaceBetween: 25,
    },
    1023: {
      slidesPerView: 4,
      spaceBetween: 25,
    },
  };
  return insights ? (
    <div className='lg:pb-20 pb-24'>
      <div>
        {line && <hr className='tb__line' />}
        <p className='p2 lg:my-8'>{contentType || 'INSIGHTS'}</p>
      </div>
      <Swiper
        className='swiper'
        breakpoints={swiperConfig}
        centerInsufficientSlides
      >
        {insights.map((insight) => (
          <SwiperSlide className='slide__fit'>
            <Link to={`/insight/${insight.slug}`}>
              <div className='flex flex-col gap-3'>
                <img
                  src={getImageUrl(insight.coverImage.hash, 'co_rgb:052A2D,e_colorize:52')}
                  alt='Insight'
                  className='insight__img'
                />
                <h5>{insight.title}</h5>
                <p className='p5 line-clamp-3 max-sm:hidden'>{insight.introduction}</p>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  ) : null;
}

export default Insights;
